module.exports = __webpack_public_path__ + "img/dollar.8f4ea902.svg";